"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StarIcon = _interopRequireDefault(require("../../Icons/StarIcon"));

var _EmptyStarIcon = _interopRequireDefault(require("../../Icons/EmptyStarIcon"));

var _ThemeManager = _interopRequireDefault(require("../../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is often used in signify favorite item.  For example bookmark.
 *
 * See [design](http://nutanix.design/2.0/#Components_Stars)
 *
 * @keywords Checkbox, Toggle, Favorite, Star
 */
var Favorite =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Favorite, _React$Component);

  function Favorite(props) {
    var _this;

    _classCallCheck(this, Favorite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Favorite).call(this, props));
    _this.handleOnClick = _this.handleOnClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Favorite, [{
    key: "handleOnClick",
    value: function handleOnClick(event) {
      if (this.props.onClick) {
        this.props.onClick(!this.props.checked, event);
      }
    }
    /**
     * Get the checked style star icon for the given background style.
     * @param {string} background - See PropTypes.background
     * @returns {ReactNode} - react node.
     */

  }, {
    key: "getCheckedStarIcon",
    value: function getCheckedStarIcon(background) {
      var result;

      switch (background) {
        case 'dark':
          result = _react.default.createElement(_StarIcon.default, {
            color: _ThemeManager.default.getVar('gray-3')
          });
          break;

        default:
          // white
          result = _react.default.createElement(_StarIcon.default, {
            color: _ThemeManager.default.getVar('gray-1')
          });
      }

      return result;
    }
    /**
     * Get the unchecked style star icon for the given background style.
     * @param {string} background - See PropTypes.background
     * @returns {ReactNode} - react node.
     */

  }, {
    key: "getUncheckedStarIcon",
    value: function getUncheckedStarIcon(background) {
      var result;

      switch (background) {
        case 'dark':
          result = _react.default.createElement(_EmptyStarIcon.default, {
            color: _ThemeManager.default.getVar('gray-3')
          });
          break;

        default:
          // white
          result = _react.default.createElement(_EmptyStarIcon.default, {
            color: _ThemeManager.default.getVar('gray-1')
          });
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      // onClick is used in handleOnClick.
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
          className = _this$props.className,
          background = _this$props.background,
          checked = _this$props.checked,
          onClick = _this$props.onClick,
          props = _objectWithoutProperties(_this$props, ["className", "background", "checked", "onClick"]);

      var starIconNode;

      if (checked) {
        starIconNode = this.getCheckedStarIcon(background);
      } else {
        starIconNode = this.getUncheckedStarIcon(background);
      }

      var mergedClassNames = (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), " ").concat(_ThemeManager.default.getVar('classPrefix'), "-favorite"));
      return _react.default.cloneElement(starIconNode, _objectSpread({
        className: mergedClassNames,
        onClick: this.handleOnClick
      }, props));
    }
  }]);

  return Favorite;
}(_react.default.Component);

exports.default = Favorite;
Favorite.propTypes = {
  /**
   * Optional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * For white or dark background.
   */
  background: _propTypes.default.oneOf(['white', 'dark']),

  /**
   * Property to indicate if the item is checked or marked.
   */
  checked: _propTypes.default.bool,

  /**
   * Callback when component is clicked.
   * onClick(inverse of props.checked, event)
   */
  onClick: _propTypes.default.func
};
Favorite.defaultProps = {
  background: 'white',
  checked: false
};